export default __webpack_public_path__ + "static/media/logo_transparent.2d4666a8.png";